export default __webpack_public_path__ + "static/media/uvas.79da786c.jpg";